import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/types/content";

interface FeaturedSectionProps {
  articles: Article[];
}

export default function FeaturedSection({ articles }: FeaturedSectionProps) {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="精选话题"
        title="值得花时间读完的梳理"
        desc="不是最快的那一条，而是把前因后果讲清楚的那一篇。"
        moreTo="/rank"
        moreLabel="浏览全部话题"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}